import type { JSX } from 'react';

import { Calendar, User } from 'lucide-react';

import { cn } from '@/lib/utils';

import { PRIORITY_STYLES } from '../../config/activity-display';
import type { TaskActivityItem } from '../../model/activity';

interface TaskActivityContentProps {
  item: TaskActivityItem;
}

const TaskActivityContent = ({ item }: TaskActivityContentProps): JSX.Element => {
  const priority = PRIORITY_STYLES[item.priority];
  const dueSoon = item.dueAt ? new Date(item.dueAt).getTime() - Date.now() < 1000 * 60 * 60 * 24 * 2 : false;

  return (
    <div className="flex flex-col gap-1.5">
      <p className="m-0 text-sm font-medium text-text-default font-body">{item.title}</p>
      <div className="flex flex-wrap items-center gap-2">
        <span className={cn('rounded px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide', priority.bg)}>
          Prioridad {priority.label}
        </span>
        {item.assigneeName ? (
          <span className="inline-flex items-center gap-1 text-xs text-text-muted font-body">
            <User className="size-3 shrink-0" aria-hidden />
            {item.assigneeName}
          </span>
        ) : null}
        {item.dueAt ? (
          <span
            className={cn(
              'inline-flex items-center gap-1 text-xs font-body',
              dueSoon ? 'text-red-700 font-semibold' : 'text-text-muted'
            )}
          >
            <Calendar className="size-3 shrink-0" aria-hidden />
            Vence{' '}
            {new Date(item.dueAt).toLocaleDateString('es-CL', {
              day: '2-digit',
              month: 'short',
            })}
          </span>
        ) : null}
      </div>
    </div>
  );
};

export default TaskActivityContent;
